import type { RegisterWhatsAppPhoneRequest, RegisterWhatsAppPhoneResponse } from "@multi-chat/shared";
import { registerWhatsAppPhone } from "../../../api/whatsapp-api.js";

type RegisterVerifiedPhone = (
  organizationId: number,
  phoneNumberId: string,
  request: RegisterWhatsAppPhoneRequest,
) => Promise<RegisterWhatsAppPhoneResponse>;

/** The only client entry for Cloud API registration after ownership is verified. */
export function registerVerifiedWhatsAppPhone(
  organizationId: number,
  phoneNumberId: string,
  request: RegisterWhatsAppPhoneRequest = {},
  register: RegisterVerifiedPhone = registerWhatsAppPhone,
): Promise<RegisterWhatsAppPhoneResponse> {
  return register(organizationId, phoneNumberId, request);
}
